<template>
  <article class="minhaconta__body banking" v-if="loaded">
    <addBankAccount
      v-if="modalActive != null"
      @cancel="modalActive = null"
      @success="getAccounts()"
      :active.sync="modalActive"
      :bankAccounts="bankAccounts"
      :banks="banks"
    />

    <header class="banking__header">
      <p class="banking__description">
        O cadastramento de uma conta bancária, que esteja no nome do médico,
        é obrigatório para a utilização do sistema. É nesta conta que serão
        depositados os valores advindos do aplicativo Dr. Conecta.
      </p>

      <button @click="modalActive = -1" class="btn btn-primary banking__new">
        + Adicionar conta
      </button>
    </header>

    <section class="banking__list">
      <div
        v-for="(bankAccount, $index) in bankAccounts"
        :key="$index"
        :class="$index === 0 ? 'main-account' : 'secondary-account'"
        class="banking__item account"
      >
        <div class="card banking__item-wrapper">
          <header class="banking__item-header">
            <span v-show="$index === 0" class="checked checked-true">
              <i class="icon icon-check" />
            </span>

            <strong><!-- tipo de conta (no css) --></strong>

            <span class="actions">
              {{bankAccount.index}}

              <a @click="edit($index)">
                <i class="icon icon-more-vert" />
              </a>
              <!-- <i @click="remove($index)" class="icon icon-delete"></i> -->
            </span>
          </header>

          <section class="banking__item-body">
            <dl class="banking__item-details">
              <template v-for="(field, $key) in bankAccount">
                <dt
                  v-if="field.label && field.value"
                  class="banking__item-key"
                  :key="'dt' + $key"
                >
                  {{field.label}}
                </dt>

                <dd
                  v-if="field.label && field.value"
                  class="banking__item-val"
                  :key="'dd' + $key"
                >
                  {{field.value}}
                </dd>
              </template>
            </dl>
          </section>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import addBankAccount from '@/components/modals/addBankAccount'

export default {
  components: {
    addBankAccount
  },
  data () {
    return {
      modalActive: null,
      bankAccounts: [],
      loaded: false,
      selected: null,
      banks: [],
      bankData: {
        'account_name': {
          label: 'Nome da conta',
          value: null
        },
        'is_active': {
          label: null,
          value: null
        },
        'account_type': {
          label: 'tipo',
          value: null
        },
        'bank': {
          label: 'banco',
          value: null,
          id: null
        },
        'agency': {
          label: 'agência',
          value: null
        },
        'agency_digit': {
          label: null,
          value: null
        },
        'account_number': {
          label: 'conta',
          value: null
        },
        'account_digit': {
          label: null,
          value: null
        }
      }
    }
  },
  mounted () {
    this.fn_SHOW_PROGRESS()
    if (!this.loaded) {
      this.$http.get(`/bank`, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.banks = res.data
          this.getAccounts()
        }
      )
    }
  },
  methods: {
    getAccounts () {
      this.bankAccounts = []
      this.modalActive = null
      let index = 0
      this.loaded = false
      this.$http.get(`/doctor/bank_detail`, this.$store.getters.getAuthHeader).then(
        (res) => {
          let obj = {}
          let newObj = {}
          for (let account of res.data) {
            obj = account
            newObj = this.fn_COPY_OBJECT(this.bankData)
            for (let field in obj) {
              if (newObj[field]) {
                newObj[field].value = obj[field]
              }
              if (field === 'bank') {
                newObj.bank.id = obj[field].id
              }
            }

            newObj.bank.value = newObj.bank.value.name
            newObj.agency.value = newObj.agency.value + (newObj.agency_digit.value ? '-' + newObj.agency_digit.value : '')
            newObj.account_number.value = newObj.account_number.value + (newObj.account_digit.value ? '-' + newObj.account_digit.value : '')
            newObj.id = account.id
            // delete newObj.agency_digit
            // delete newObj.account_digit
            index = index++
            if (newObj.is_active.value) {
              this.bankAccounts.unshift(newObj)
            } else {
              this.bankAccounts.push(newObj)
            }
          }
          console.log(newObj)
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        }
      ).catch(
        (err) => {
          console.log(err)
          this.loaded = true
          this.fn_HIDE_PROGRESS()
        }
      )
    },
    edit (index) {
      this.modalActive = index
    }
  }
}
</script>
